import { action, observable, runInAction } from 'mobx';

import {ajax } from 'hrone-react';
export class MainLoginStore {
    @observable isShowRegister = false;
    @observable isShowResetPassword = false;

    @observable areaCodeOptions: any = [];

    @action
    getAreaCodeOptions = async () =>{
        const _AreaCodeList = await ajax.get('/v1/kiosk-web/areaCode/getAllAreaCode');
        const AreaCodeList = _AreaCodeList.map((item: any) => {
            return { label: item.areaLabel, value: item.areaValue };
        });
        runInAction(() => {
            this.areaCodeOptions = AreaCodeList;
        });

    }

    @action
    toResetPassword = () => {
        this.isShowResetPassword = !this.isShowResetPassword;
    };

    @action
    toRegister = () => {
        this.isShowRegister = !this.isShowRegister;
    };
}

export default new MainLoginStore();
